import main from '@/translations/he/pages/main';
import privacy from '@/translations/he/pages/privacy';
import agreement from '@/translations/he/pages/agreement';
import error from '@/translations/he/pages/error';
import disclosure from '@/translations/he/pages/disclosure';
import prices from '@/translations/he/pages/prices';
import personal from '@/translations/he/pages/personal';
import contact from '@/translations/he/pages/contact';
import team from '@/translations/he/pages/team';
import header from '@/translations/he/components/header';
import footer from '@/translations/he/components/footer';
import service from '@/translations/he/pages/service';
import global from '@/translations/he/global';

const translation = {
  translation: {
    global,
    pages: {
      main,
      privacy,
      agreement,
      error,
      disclosure,
      prices,
      team,
      personal,
      service,
      contact,
    },
    components: {
      header,
      footer,
    },
  },
};

export default translation;
